import {createGetAllMethod} from "../core/factory";
import {entityType} from "./module";

export const getAllPermissions = () => createGetAllMethod(entityType)